import styled from 'styled-components';
import Modal from "../../../common/Modal";
import useReadingSessionStore from './useReadingSessionStore';
import {Button as BootstrapButton} from "react-bootstrap";
import RowSpacer from "../../../common/styles/RowSpacer";
import ColSpacer from "../../../common/styles/ColSpacer";
import BookPageBar from "../../../common/BookPageBar";
import LoadingBar from "../../../common/LoadingBar";
import BookPageBarLoading from "../../../common/BookPageBarLoading";
import BooksitoutImages from "../../../images/BooksitoutImages";
import BottomCTA from "../../../common/button/BottomCTA";

const BookReadingSessionModal = () => {
    const {isTimerModalOpen, closeTimerModal} = useReadingSessionStore()

    return (
        <Modal
            titleText={'독서활동 기록하기'}
            isShowing={isTimerModalOpen}
            onClose={closeTimerModal}
            body={<Body/>}
            size={'xl'}
        />
    )
}

const Body = () => {
    const {
        currentReadingSession,
        timerInSeconds, isTimerOn,
        resumeTimer, pauseTimer,
        openEndModal
    } = useReadingSessionStore()

    const hours = Math.floor(timerInSeconds / 3600)
    const minutes = Math.floor((timerInSeconds % 3600) / 60)
    const seconds = timerInSeconds % 60

    return (
        <>
            {
                currentReadingSession !== null && currentReadingSession.book !== null
                    ?
                    (
                        <>
                            <BookContainer>
                                <BookCover src={currentReadingSession.book.cover !== '' && currentReadingSession.book.cover != null ? currentReadingSession.book.cover : BooksitoutImages.Placeholder.bookCover ?? ''}
                                           alt={currentReadingSession.book.title}/>

                                <ColSpacer/>

                                <BookInfoContainer>
                                    <BookTitle>{currentReadingSession.book.title}</BookTitle>
                                    <BookAuthor>{currentReadingSession.book.author}</BookAuthor>
                                    <BookPageBar book={currentReadingSession.book}/>
                                </BookInfoContainer>
                            </BookContainer>

                            <RowSpacer size={10}/>
                        </>
                    )
                    :
                    (
                        <>
                            <BookContainer>
                                <BookCover src={BooksitoutImages.Placeholder.bookCoverLoading}
                                           alt={"loading"}/>

                                <ColSpacer/>

                                <BookInfoContainer>
                                    <BookTitle><LoadingBar size={12}/></BookTitle>
                                    <BookAuthor><LoadingBar size={8}/></BookAuthor>
                                    <BookPageBarLoading/>
                                </BookInfoContainer>
                            </BookContainer>

                            <RowSpacer size={10}/>
                        </>
                    )
            }

            <TimerContainer>
                {hours}시간 {minutes}분 {seconds}초
            </TimerContainer>

            <TimerButtonContainer>
                {/*@ts-ignore*/}
                <PauseButton
                    variant={isTimerOn ? 'pause' : 'resume'}
                    onClick={isTimerOn ? pauseTimer : resumeTimer}
                >
                    {isTimerOn ? '일시정지' : '재시작'}
                </PauseButton>
            </TimerButtonContainer>

            <BottomCTA message={'독서활동 끝내기'} onClick={openEndModal} />
        </>
    )
}

const BookContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const BookCover = styled.img.attrs({
    className: 'img-fluid rounded border'
})`
    max-height: 100px;
`;

const BookInfoContainer = styled.div.attrs({})`
    display: flex;
    flex-direction: column;
    text-align: center;
    min-width: 100px;
`

const BookTitle = styled.h1`
    font-size: 1.2rem;
`;

const BookAuthor = styled.h2.attrs({
    className: 'text-secondary'
})`
    font-size: 1rem;
`;

const TimerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    margin: 1rem;
`

const TimerButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 1rem 0;
`

const PauseButton = styled(BootstrapButton)`
    border-radius: 16px;
    font-weight: 600;
    padding: 8px 20px;
    min-width: 100px;
`

export default BookReadingSessionModal
